import React, { useCallback } from "react";
import { useModal } from "react-modal-hook";
import { useGetAccountDocumentTemplatesForMapLazyQuery } from "../../../generated/graphql";
import Modal from "../../Common/Modal";
import { GenerateDocumentForm } from "../../DocumentUploads/GeneratedDocuments/GenerateDocumentForm";
import { filterObjectDocumentTemplates, ListObject } from "./utils";

export const useGenerateFromTemplateModal = ({
  object,
}: {
  object: ListObject;
}) => {
  const [getDocumentTemplates, { data }] =
    useGetAccountDocumentTemplatesForMapLazyQuery({
      fetchPolicy: "network-only",
      onCompleted: () => showGenerateFromTemplateModal(),
    });

  const [showGenerateFromTemplateModal, hideGenerateFromTemplateModal] =
    useModal(
      () => (
        <Modal onRequestClose={hideGenerateFromTemplateModal}>
          <GenerateDocumentForm
            object={object}
            documentTemplates={filterObjectDocumentTemplates(
              object,
              data?.account?.documentTemplates,
            )}
            closeModal={() => hideGenerateFromTemplateModal()}
          />
        </Modal>
      ),
      [data, object],
    );

  const showModalCallback = useCallback(() => {
    void getDocumentTemplates();
  }, [getDocumentTemplates]);

  return [showModalCallback] as const;
};
